import { ItalicMarkSpec, ITALIC_KEY } from '@techchange/pm-specs';

import ItalicsButton from './components/ItalicsButton';
import italicsKeymap from './plugins/keymap';

const italics = {

	marks() {

		return {
			[ITALIC_KEY]: ItalicMarkSpec,
		};

	},

	plugins() {

		return [italicsKeymap];

	},

	toolbarButtons() {

		return [{ Button: ItalicsButton, key: 'ItalicsButton' }];

	},

};

export default italics;
